import { SwiperSlide } from "swiper/react";
import { Container, Carousel, SliceBorder, Button } from "../../../../shared/ui";

import { useMediaQuery } from "../../../../shared/hooks/useMediaQuery";
import { generateMediaQuery } from "../../../../shared/lib/helpers";
import { MediaQueryProperty, MediaSizeEnum } from "../../../../shared/constants/media";

import styles from "./CollectionPros.module.scss";

import { prosData, prideData, swiperMobileProps } from "../../const";
import { CardPros } from "../CardPros";
import { CardPride } from "../CardPride";
import { getRouteAbout } from "../../../../shared/constants/routes";

import type { CSSProperties } from "react";

const listPros = prosData.map((data, index) => (
    <SwiperSlide key={index} className={styles.slide}>
        <CardPros {...data} />
    </SwiperSlide>
));

const listPride = prideData.map((data, index) => (
    <SwiperSlide key={index}>
        <CardPride {...data} />
    </SwiperSlide>
));

export const CollectionPros = () => {
    const isMobile = useMediaQuery(generateMediaQuery(MediaQueryProperty.MaxWidth, MediaSizeEnum.sm));
    const isMobileNav = useMediaQuery(generateMediaQuery(MediaQueryProperty.MaxWidth, MediaSizeEnum.md));
    const isTablet = useMediaQuery(
        `(${MediaQueryProperty.MinWidth}: ${MediaSizeEnum.sm}) and (${MediaQueryProperty.MaxWidth}: ${MediaSizeEnum.lg})`,
    );

    const sliceRadius = () => {
        if (isMobile) {
            return 12;
        }
        if (isTablet) {
            return 25;
        }
        return 50;
    };

    return (
        <div className={styles.wrapper}>
            <div className={styles.scroll} id="energy" />
            <SliceBorder
                sizeRadius={sliceRadius()}
                multiplierInside={1}
                border={{ topRight: "outside-corner-lateral", bottomRight: "inside" }}
            >
                <Container className={styles.titleWrapper}>
                    <h2 className={styles.title}>Почувствуйте энергию&nbsp;лидерства</h2>
                </Container>
            </SliceBorder>
            <Container marginSize={!isMobile ? "standard" : undefined}>
                {!isMobile && (
                    <div className={styles.about}>
                        <p className={styles.titleAbout}>Откройте для себя мир &nbsp;БКС</p>
                        <Button as="link" to={getRouteAbout()} className={styles.button}>
                            Всё о&nbsp;компании
                        </Button>
                    </div>
                )}
                <Carousel
                    className={styles.carouselFirst}
                    loop={false}
                    spaceBetween={isMobile ? 0 : 20}
                    slidesOffsetBefore={isMobile ? 20 : 0}
                    slidesOffsetAfter={isMobile ? 20 : 0}
                    {...swiperMobileProps}
                    style={{ "--space-between-slide": isMobile ? "0" : "20px" } as CSSProperties}
                >
                    {listPros}
                </Carousel>
                <Carousel
                    className={styles.carouselSecond}
                    spaceBetween={!isTablet ? 54 : 20}
                    loop={false}
                    slidesOffsetBefore={isMobile ? 20 : 0}
                    slidesOffsetAfter={isMobile ? 20 : 0}
                    {...(isMobileNav && swiperMobileProps)}
                >
                    {listPride}
                </Carousel>
            </Container>
        </div>
    );
};
